import { Fragment, useContext, useEffect } from 'react'
import logoApidDoc from '../../assets/img/apidocs-logo.png'
import InputBaseSearch from '../../components/inputs/InputBaseSearch'
import { DashboardContext } from '../../context'
import useSearchItemGenerator from '../../hooks/useSearchItemGenerator'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { URLAPP, URLQUERY } from '../../config'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Typography } from '@mui/material'
import useDocumentTitle from '../../hooks/useDocumentTitle'
import PageMotion from '../../components/containers/PageMotion'
import useNotificationsList from '../../hooks/useNotificationsList'
import NotificationCard from '../../components/profile/NotificationCard'

const MIN_SEARCH_LENGTH = 3

export default function Home() {
  const dashboardContext = useContext(DashboardContext)
  const searchResult = useSearchItemGenerator({ dashboardContext, minSearchLength: MIN_SEARCH_LENGTH })
  const [searchParams, setSearchParams] = useSearchParams({})
  const { notifications, searchLastNotifications } = useNotificationsList()
  const controlDocTitle = useDocumentTitle()
  const navigate = useNavigate()

  useEffect(() => {
    if (searchParams.get(URLQUERY.search) && searchParams.get(URLQUERY.search) !== searchResult.search) {
      searchResult.setSearch(searchParams.get(URLQUERY.search) || '')
    }
  }, [searchParams])

  useEffect(() => {
    if (searchParams.get(URLQUERY.search) !== searchResult.search) {
      setSearchParams(searchResult.search ? { [URLQUERY.search]: searchResult.search } : undefined)
      controlDocTitle(`Búsqueda ${searchResult.search}`)
    }
  }, [searchResult.search])


  useEffect(() => {
    searchLastNotifications(10)
  }, [])

  return (
    <PageMotion className='home' style={{ width: '100%', margin: '0' }}>
      <div className={`browser ${searchResult.search && 'on-search'}`}>
        <img
          src={logoApidDoc}
          alt="logo-apidoc"
          className={`browser-logo`}
        />
        <div className='browser-search'>
          <InputBaseSearch search={searchResult.search} onSearch={searchResult.setSearch} />
        </div>
        {!searchResult.search && notifications.length > 0 && <div className='home-notifications'>
          <fieldset>
            <Typography component={'legend'} color={'gray'}>Actividad reciente</Typography>
            {notifications.map(n => <NotificationCard key={n.id} {...n} />)}
          </fieldset>
          <div className='d-flex'>
            <Button className='m-auto' fullWidth onClick={() => navigate(URLAPP.profile)}>Ver más</Button>
          </div>
        </div>}
      </div>
      {searchResult.search ? <>
        {searchResult.matchItems.length > 0 ? <>
          <Typography variant='caption' sx={{ marginLeft: 'auto', marginRight: '1rem' }}>
            <span data-testid="searched-items">{searchResult.matchItems.length}</span> elementos encontrados
          </Typography>
          <ul className='matches'>
            {searchResult.matchItems.map((item, idx) => <li key={idx}>
              <Typography variant='subtitle1'>
                <FontAwesomeIcon icon={item.icon} /> <Link to={item.link}>{item.title}</Link>
              </Typography>
              <Typography variant='caption' dangerouslySetInnerHTML={{ __html: item.description }} /><br />
              <Typography variant='caption' className='gray'>
                {item.keywords.map(keyword => <Fragment key={keyword}>
                  <Link to={`/dashboard?${URLQUERY.search}=${keyword}`}>{keyword}</Link>{', '}
                </Fragment>)}
              </Typography>
            </li>)}
          </ul>
        </> : <div className='m-auto text-error'>
          <Typography variant='h1' className={searchResult.search.length < MIN_SEARCH_LENGTH ? 'gray' : ''}>
            <FontAwesomeIcon icon='search' />
          </Typography>
          <Typography variant='subtitle1' className={searchResult.search.length < MIN_SEARCH_LENGTH ? 'gray' : ''}>
            {searchResult.search.length < MIN_SEARCH_LENGTH ?
              `Ingrese un mínimo de ${MIN_SEARCH_LENGTH} caracteres` :
              'No se encontraron resultados'
            }
          </Typography>
        </div>}
      </> : <>
      </>}
    </PageMotion>
  )
}
